module.exports = __webpack_public_path__ + "static/sylwiawork4-0999ee2ab99c1754e7f04170267be3c4.jpg";